module.exports = __webpack_public_path__ + "static/media/1d88a9b0-aac0-40df-baf7-a630cd19cc5d.7465ce79.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/Fonts/1d88a9b0-aac0-40df-baf7-a630cd19cc5d.ttf
// module id = 86
// module chunks = 0